<div class="m-0  mt-2 md:mt-0" >
  <label>
    Date:
    <p-datepicker
      class="date-input"
      inputStyleClass="text-box"
      [(ngModel)]="selectedCalendarDate"
      (ngModelChange)="updateCurrentDate()"
      [name]="this.currentQuestion.GUID + 'date'"
      [disabled]="currentQuestion.NASelected"
      placeholder="Please select a date"
      dateFormat="dd M yy"
      [showIcon]="false"
      ></p-datepicker>
    </label>
  </div>
  @if (includeTime) {
    <div class="m-0  mt-2 " >
      <label>
        Time:
        <p-datepicker
          class="date-input"
          inputStyleClass="text-box"
          [(ngModel)]="selectedTime"
          (ngModelChange)="updateCurrentDate()"
          [name]="currentQuestion.GUID + 'time'"
          [disabled]="currentQuestion.NASelected"
          placeholder="Please select a time"
          [showTime]="true"
          [timeOnly]="true"
          hourFormat="24"
          [showIcon]="false"
          ></p-datepicker>
        </label>
      </div>
    }
    @if (currentQuestion.AllowNA) {
      <div class="mt-4 mx-2 flex items-center" >
        <app-simple-toggle class="mr-2" [(isChecked)]="currentQuestion.NASelected" (isCheckedChange)="validateAnswered()"></app-simple-toggle>
        <label (click)="updateNA()" class="hover:cursor-pointer">Not Applicable</label>
      </div>
    }
